export const INTERVIEW_TYPE = {
    COMPANY : 'company',
    DSA : 'dsa',
    CONTEST : 'contest'
}

export const MockPublishingSteps = {
    CHOOSE_COMPANY : 'Choose Company',
    MOCK_DETAILS : 'Choose mock details',
    PUBLISHING_PROCTORING : 'Setup Publishing & Proctoring'
}

export const ChallengeDifficulty = {
    very_easy: "Very easy",
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
};

export const TemplateType = {
    MOCK : "mock",
    CONTEST : "contest",
    PERSONALIZED : "personalized",
}